Array.prototype.unique = function() {
   return [... new Set(this)];
};

Array.prototype.remove = function(items, callback) {

    let toRemove = Array.isArray(items) ? items : [items];
    //let newArray = this;
    
    if (callback) {
        return this.filter(a => {
            return toRemove.find(b => callback(a,b)) === undefined;
        });
    }
    else {
        return this.filter(a => toRemove.find(b => a === b) === undefined);
    }

}

Array.prototype.equals = function(arr) {
    return arr && this.length === arr.length && this.every((value, index) => value === arr[index]);
}

Array.prototype.intersection = function(arr) {
    return this.filter(item => arr.includes(item));
}

Array.prototype.hasIntersectionWith = function(arr) {
    const intersection = this.intersection(arr);
    return intersection.length !== 0;
}

Array.prototype.splitByIntersection = function(intersection) {
		
    const groups = [];
    let current = [];

    for (const value of this) {
        if (intersection.includes(value)) {
            if (current.length) groups.push(current);
            current = []
        }
        else {
            current.push(value);
        }
    }

    if (current.length) groups.push(current);
    
    return groups;

}

Array.prototype.groupByNeighbourhood = function() {
      const res = [[this[0]]];
      
      for (let i=1; i<this.length; ++i)  {
         const currentGroup = res[res.length-1];
         const last = currentGroup[currentGroup.length-1];
         if (this[i] === last + 1) currentGroup.push(this[i]);
         else res.push([this[i]]);
      }
      
      return res;
      
}
